var map = {
	"./ActionsModal/Cambio.vue": 815,
	"./ActionsModal/SaveChanges.vue": 816,
	"./ActionsModal/index.vue": 249,
	"./agrocolor.vue": 2098,
	"./araporcei.vue": 2099,
	"./coplaca/ParcelasActionsMultiple.vue": 1147,
	"./coplaca/index.vue": 2100,
	"./default.vue": 2101,
	"./demo.vue": 2102,
	"./sites.vue": 310,
	"./widgets/auditorias.vue": 817,
	"./widgets/dictamenes.vue": 820,
	"./widgets/pacs.vue": 822,
	"./widgets/revisiones.vue": 819,
	"./widgets/solicitudes.vue": 818,
	"./widgets/toma_muestras.vue": 821
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1805;